import { render } from "./ViewTranslationControl.vue?vue&type=template&id=0e592335&scoped=true"
import script from "./ViewTranslationControl.vue?vue&type=script&lang=js"
export * from "./ViewTranslationControl.vue?vue&type=script&lang=js"

import "./ViewTranslationControl.vue?vue&type=style&index=0&id=0e592335&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e592335"]])

export default __exports__